import { render, staticRenderFns } from "./UnstagedTable.vue?vue&type=template&id=8ec45f26"
import script from "./UnstagedTable.vue?vue&type=script&lang=js"
export * from "./UnstagedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports